module.exports = __webpack_public_path__ + "assets/img/kv-94b4aa3f.jpg";